import "./Segmented.css";

export type SegmentedOption<T extends string> = {
  value: T;
  label: string;
  disabled?: boolean;
};

type Props<T extends string> = {
  value: T;
  onChange: (value: T) => void;
  options: SegmentedOption<T>[];
  ariaLabel?: string;
};

/** Compact segmented control (e.g. Claro / Escuro / Auto). */
export function Segmented<T extends string>({ value, onChange, options, ariaLabel }: Props<T>) {
  return (
    <div className="ui-segmented" role="group" aria-label={ariaLabel}>
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          disabled={o.disabled}
          aria-pressed={o.value === value}
          className={`ui-segmented-opt ${o.value === value ? "on" : ""}`}
          onClick={() => !o.disabled && o.value !== value && onChange(o.value)}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
